<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h1 class="u">Настройки</h1>
    <div class="sub-nav">
      <router-link class="btn btn-default btn-sm" :to="{ name: 'cities' }">Города</router-link>
      <router-link class="btn btn-default btn-sm" :to="{ name: 'bank-transactions' }">Банковские транзакции</router-link>
      <router-link class="btn btn-default btn-sm" :to="{ name: 'rate-plans' }">Тарифные планы</router-link>
      <router-link class="btn btn-default btn-sm" :to="{ name: 'discounts' }">Скидки</router-link>
      <router-link class="btn btn-default btn-sm" :to="{ name: 'bill-templates' }">Шаблоны квитанций</router-link>
      <router-link class="btn btn-default btn-sm" :to="{ name: 'print-orders' }">Заказы печати</router-link>
    </div>

    <company-edit-form
      :company="company"
      @after="handleAfter"
    />

  </div>
</template>

<script>
import { getCurrentCompany } from '@/services/company.service'
import { getCurrentUser } from '@/services/user.service'
import companyEditForm from '@/components/forms/company/CompanyEditForm'

export default {
  name: 'company-edit',
  components: { companyEditForm },
  data () {
    return {
      company: {
        id: null,
        name: '',
        bill_template: ''
      },

      user: {
        id: null,
        email: '',
        username: ''
      },

      show_additional: false
    }
  },
  mounted () {
    this.getCurrentCompany().then((response) => {
      this.company = response.data
    })
    this.getCurrentUser().then((response) => {
      this.user = response.data
    })
  },
  methods: {
    getCurrentCompany: getCurrentCompany,
    getCurrentUser: getCurrentUser,

    handleAfter (success) {
      console.log(success)
    },
    showMsg (msg) {
      this.$parent.showPopupMsg(msg)
    }
  }
}
</script>



// WEBPACK FOOTER //
// CompanyEdit.vue?268d68c9